export default __webpack_public_path__ + "locales/pl/People.json?hash=cbcbb5fdb53c8ea40e97c576e7d852f2";